/* eslint-disable import/no-extraneous-dependencies */

// Example
// graphql.query('TRANSPORTER_LIST', (_, res, ctx) => res(ctx.data(PAGINATED_TRANSPORTERS), ctx.delay(2000))),
const handlers = [];

export default handlers;
